import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";

import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import FlightsStyles from "./styles/FlightStyles";
import FlightList from "./components/FlightListOutstandingSlr";


const AccessControl = require ("../../AccessControl");

function OutstandingSpecialLoads(props) {
  const classes = makeStyles(FlightsStyles)();
  const { isAuthenticated, user } = useAuth0();

  const [state, setState] = useState({
    canEdit: AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS"]),
    canEditFuelLogs: AccessControl.userHasAccess(user, ["Update FUEL LOGS"]),
    // Tabs are zero indexed
    monthTabIndex: "Current",
    year: 0,  //flightTabs.values[1].year,
    month: 0, //flightTabs.values[1].month
  });

  return (isAuthenticated &&
    <div
      className="OutstandingSpecialLoads"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        //minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="trips"
        pageName="Flights with Special Loads"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          backgroundColor: "#ffffff",
          minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`
        }}
      >
        <div className={classes.rooted} style={{ minHeight: `calc(100vh - ${(99+2+10+94)}px)`, height: `calc(100vh - ${(99+2+10+94)}px)`, width: `calc(100vw - 120px)`, maxWidth: `calc(100vw - 120px)`}}>
          <FlightList month={state.month} year={state.year} canEdit={state.canEdit} classes={classes} canEditFuelLogs={state.canEditFuelLogs}/>
        </div>
      </div>
      <PageFooter/>
    </div>

  );
}

export default OutstandingSpecialLoads;
